/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_State_Select_ValidationInputs */

const en_explorer_info_state_select_validation = /** @type {(inputs: Explorer_Info_State_Select_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a new state.`)
};

const fr_explorer_info_state_select_validation = /** @type {(inputs: Explorer_Info_State_Select_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez selectionner un nouvel etat.`)
};

const de_explorer_info_state_select_validation = /** @type {(inputs: Explorer_Info_State_Select_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie einen neuen Bundesstaat.`)
};

const it_explorer_info_state_select_validation = /** @type {(inputs: Explorer_Info_State_Select_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un nuovo stato.`)
};

const ru_explorer_info_state_select_validation = /** @type {(inputs: Explorer_Info_State_Select_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, выберите новый штат.`)
};

const es_explorer_info_state_select_validation = /** @type {(inputs: Explorer_Info_State_Select_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione un nuevo estado.`)
};

const zh_cn2_explorer_info_state_select_validation = /** @type {(inputs: Explorer_Info_State_Select_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请选择一个新的州。`)
};

const ja_explorer_info_state_select_validation = /** @type {(inputs: Explorer_Info_State_Select_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい州を選択してください。`)
};

const hi_explorer_info_state_select_validation = /** @type {(inputs: Explorer_Info_State_Select_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया एक नया राज्य चुनें।`)
};

const pt_pt2_explorer_info_state_select_validation = /** @type {(inputs: Explorer_Info_State_Select_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, selecione um novo estado.`)
};

/**
* | output |
* | --- |
* | "Please select a new state." |
*
* @param {Explorer_Info_State_Select_ValidationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_state_select_validation = /** @type {((inputs?: Explorer_Info_State_Select_ValidationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_State_Select_ValidationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_state_select_validation(inputs)
	if (locale === "de") return de_explorer_info_state_select_validation(inputs)
	if (locale === "it") return it_explorer_info_state_select_validation(inputs)
	if (locale === "ru") return ru_explorer_info_state_select_validation(inputs)
	if (locale === "es") return es_explorer_info_state_select_validation(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_state_select_validation(inputs)
	if (locale === "ja") return ja_explorer_info_state_select_validation(inputs)
	if (locale === "hi") return hi_explorer_info_state_select_validation(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_state_select_validation(inputs)
	return en_explorer_info_state_select_validation(inputs)
});